<header class="pt-topbar bg-accent detail-header-gallery mb-5" [class.has--single-image]="singleImage$()">
  <div class="container py-4 detail-header-gallery__inner">
    <main class="row z-2 position-relative">
      <div class="col-24">
        <ng-content></ng-content>
      </div>
      <div class="col-md-12" [ngClass]="singleImage$() ? 'section-inset-t pb-4 pb-md-7' : ''">
        @if (subtitle()) {
          <strong class="fs-body-md fw-normal mb-2 d-inline-block w-100">{{ subtitle() }}</strong>
        }
        @if (title()) {
          <h1 class="h2">{{ title() }}</h1>
        }

        @if (intro() && singleImage$()) {
          <div
            class="markdown-content"
            fstrDynamicContent
            [innerHTML]="intro()! | resizeHtmlImages | stripEmbed: cookiePreferences() || undefined | safe"
          ></div>
        }
      </div>

      @if (intro() && !singleImage$()) {
        <div class="col-md-12 pt-md-4 pb-md-3">
          <div
            class="markdown-content"
            fstrDynamicContent
            [innerHTML]="intro()! | resizeHtmlImages | stripEmbed: cookiePreferences() || undefined | safe"
          ></div>
        </div>
      }

      @if (singleImage$(); as image) {
        <div class="col-md-12 single-image d-flex align-items-end">
          <fstr-image [image]="image" [priority]="true" [width]="1200" [height]="1200" [mode]="'max'"></fstr-image>

          @if (image?.caption) {
            <span class="ps-2 caption">{{ image?.caption }}</span>
          }
        </div>
      }
    </main>
  </div>

  @if ((images()?.length || 0) > 1) {
    <figure class="detail-header-gallery__media">
      @if ((images()?.length || 0) > 0) {
        <swiper-container class="position-relative z-2" init="false" #swiper>
          @for (image of sliderImages(); track image; let i = $index) {
            <swiper-slide class="swiper-slide">
              <!--<img [src]="image.url" alt="" />-->

              <article class="d-flex gap-2 flex-column">
                <fstr-image
                  [attr.data-object-position]="image?.anchor"
                  [image]="image"
                  [priority]="true"
                  [width]="1200"
                  [height]="1200"
                  [mode]="'max'"
                ></fstr-image>
                @if (image?.caption) {
                  <h2 class="ps-2 caption max-lines-2">{{ image?.caption }}</h2>
                }
              </article>
            </swiper-slide>
          }
        </swiper-container>
      }
    </figure>
  }
</header>

@if (allowSlideNext || allowSlidePrev) {
  <div class="container">
    <div class="d-none d-md-flex gap-1 detail-header-gallery-nav">
      <button class="button button-icon button--primary-subtle button--lg" (click)="slidePrev()" [disabled]="isBeginning">
        <fstr-icon anchor="line-icon-arrow-left"></fstr-icon>
        <span class="sr-only">Vorige</span>
      </button>
      <button class="button button-icon button--primary-subtle button--lg" (click)="slideNext()" [disabled]="isEnd">
        <fstr-icon anchor="line-icon-arrow-right"></fstr-icon>
        <span class="sr-only">Volgende</span>
      </button>
    </div>
  </div>
}
